<template>
  <div class="mx-auto">
    <b-modal
        ref="modal-nao-encontrado"
        id="modal-nao-encontrado"
        size="xl"
        :content-class="'shadow ' + getTheme"
        :title="'CDA ' + dadosCda.numeroCda + ' não encontrada!'"
        header-bg-variant="cda"
        header-text-variant="white"
        @hidden="close">
      <b-row class="mt-3">
        <b-col xs="12" md="12" class="mx-auto">
          <p>Não há registro da CDA pesquisada nos sistemas SEFA.</p>
        </b-col>
      </b-row>
      <template v-slot:modal-footer="{ hide }">
          <div class="mx-auto justify-content-center text-center">
              <b-button variant="outline-secondary mr-auto" @click="close()"> <i class="fa fa-times"></i> Voltar </b-button>
          </div>
      </template>
    </b-modal>
    <b-modal
        ref="modal-erro-mainframe"
        id="modal-erro-mainframe"
        size="xl"
        :content-class="'shadow ' + getTheme"
        :title="'Serviço temporariamente indisponível!'"
        header-bg-variant="cda"
        header-text-variant="white"
        @hidden="close">
      <b-row class="mt-3">
        <b-col xs="12" md="12" class="mx-auto">
          <p>{{ dadosCda.mensagemErro }}</p>
        </b-col>
      </b-row>
      <template v-slot:modal-footer="{ hide }">
          <div class="mx-auto justify-content-center text-center">
              <b-button variant="outline-secondary" @click="close()"> <i class="fas fa-times"></i> Fechar</b-button>
          </div>
      </template>
    </b-modal>

    <b-modal
        ref="modal-cda"
        id="modal-cda"
        size="xl"
        :content-class="'shadow ' + getTheme"
        :title="'CDA ' + dadosCda.numeroCda"
        header-bg-variant="cda"
        header-text-variant="white"
        @hidden="close">
      <template #modal-header="{ close }">
        <h5 class="modal-title">{{ 'CDA ' + dadosCda.numeroCda}}</h5>
        <b-button variant="cda" @click="relatorioPDF" class="py-0 ml-auto"><i class="fa fa-file-pdf-o"></i> Imprimir
        </b-button>
        <button class="close text-white ml-1" @click="close()" aria-label="close">&times;</button>
      </template>
      <b-row>
        <b-col xs="12" md="12" class="text-right" style="font-size: 12px; font-style: italic;">
          <span>
            {{ dadosCda.dataConsulta }}
          </span>
        </b-col>
        <b-col xs="12" md="12" class="mx-auto">
          <div id="messages" v-if="messageModal.message !== null">
            <b-alert show :variant="messageModal.variant">{{ messageModal.message }}</b-alert>
          </div>
        </b-col>
        <b-col xs="12" md="12" class="mx-auto">
          <b-card style="margin-top: 0 !important;" class="card-extrato">
            <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                compId="popupExtrato"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>

            <b-col xs="12" md="12" class="text-right" style="font-size: 20px; font-style: italic; margin: -7px 0 0 15px;" v-if="tabIndex == 0">
              <i style="cursor: pointer" @click="copiarTexto()" class="fa fa-copy"></i>
              <textarea spellcheck="false" data-ms-editor="true" style="position: fixed; visibility: hidden;" id="textareaCopy">{{ this.dadosCda.conteudoCopia }}</textarea>
            </b-col>

            <b-tabs card active-nav-item-class="text-title-selected" active-tab-class="nav-link-active"  v-model="tabIndex">
              <b-tab title="Dados Básicos" active title-link-class="text-title">
                <b-row class="mt-1 mb-0">
                  <b-col sm="6" md="2">
                    <label>Devedor Principal:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <p>{{ dadosCda.devedorPrincipal }}</p>
                  </b-col>
                  <b-col sm="6" md="2">
                    <label>CADICMS:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <p>{{ dadosCda.cadicms }}</p>
                  </b-col>
                </b-row>
                <hr class="mt-3"/>
                <b-row class="mt-1 mb-0">
                  <b-col sm="6" md="2">
                    <label>Tipo de Crédito:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <p>{{ dadosCda.tipoCredito }}</p>
                  </b-col>
                  <b-col sm="6" md="2">
                    <label>Situação:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <p>{{ dadosCda.situacao }}</p>
                  </b-col>
                </b-row>
                <b-row class="mt-1 mb-0">
                  <b-col sm="6" md="2">
                    <label>Origem:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <p>{{ dadosCda.origem }}</p>
                  </b-col>
                  <b-col sm="6" md="2">
                    <label>Bloqueio Ativo:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <p>{{ dadosCda.bloqueioAtivo }}</p>
                  </b-col>
                </b-row>
                <b-row class="mt-1 mb-0">
                  <b-col sm="6" md="2">
                    <label>Data de Inscrição:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <p>{{ dadosCda.dataInscricao }}</p>
                  </b-col>
                  <b-col sm="6" md="2">
                    <label>Complemento de Bloq.:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <p>{{ dadosCda.complementoBloqueio }}</p>
                  </b-col>
                </b-row>
                <hr class="mt-3"/>
                <b-row class="mt-1 mb-0">
                  <b-col sm="6" md="2">
                    <label>Valor Base Principal:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                      <p :style="dadosCda.valorBasePrincipal == '(moeda diversa do Real)' ? 'font-style: italic;' : ''" >{{ dadosCda.valorBasePrincipal }}</p>
                  </b-col>
                  <b-col sm="6" md="2">
                    <label>Data Base Principal:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <p>{{ dadosCda.dataBasePrincipal }}</p>
                  </b-col>
                </b-row>
                <b-row class="mt-1 mb-0">
                  <b-col sm="6" md="2">
                    <label>Valor Base Multa:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                      <p :style="dadosCda.valorMulta == '(moeda diversa do Real)' ? 'font-style: italic;' : ''" >{{ dadosCda.valorMulta }}</p>
                  </b-col>
                  <b-col sm="6" md="2">
                      <label>Data Base Multa:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <p>{{ dadosCda.dataMulta }}</p>
                  </b-col>
                </b-row>
                <b-row class="mt-1 mb-0">
                  <b-col sm="6" md="2">
                    <label>Juros Inscrito:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                      <p :style="dadosCda.juros == '(moeda diversa do Real)' ? 'font-style: italic;' : ''" >{{ dadosCda.juros }}</p>
                  </b-col>
                  <b-col sm="6" md="2" style="background-color: #EEF0F9">
                    <label>Valor Pendente:</label>
                  </b-col>
                  <b-col sm="6" md="4" style="background-color: #EEF0F9">
                      <p :style="dadosCda.valorPendente == '(moeda diversa do Real)' ? 'font-style: italic;' : ''" >{{ dadosCda.valorPendente }}</p>
                  </b-col>
                </b-row>
                <hr class="mt-3"/>
                <b-row class="mt-1 mb-0">
                    <b-col sm="6" md="2">
                        <label>Ajuizamento:</label>
                    </b-col>
                    <b-col sm="6" md="4">
                        <p>{{ dadosCda.ajuizamento }}</p>
                    </b-col>
                    <b-col sm="6" md="2">
                        <label>Protesto ativo:</label>
                    </b-col>
                    <b-col sm="6" md="4">
                        <p>{{ dadosCda.protestoAtivo }}</p>
                    </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Devedor" title-link-class="text-title"
                     style="max-height: 450px; overflow-y: auto;">
                <div v-for="devedor in dadosCda.contribuintes" :key="devedor.numeroContribuinte">
                  <hr class="mt-3 mb-3" v-if="devedor.numeroContribuinte > 1"/>
                  <b-row class="mt-1 mb-0">
                    <b-col sm="6" md="2">
                      <label>{{ "Devedor (" + devedor.numeroContribuinte + "):" }}</label>
                    </b-col>
                      <b-col sm="6" md="4">
                          <p>{{ devedor.nome }}</p>
                      </b-col>
                      <b-col sm="6" md="2" v-if="devedor.cpf != null && devedor.cpf != ''">
                          <label>CPF:</label>
                      </b-col>
                      <b-col sm="6" md="4" v-if="devedor.cpf != null && devedor.cpf != ''">
                          <p>{{ devedor.cpf }}</p>
                      </b-col>
                      <b-col sm="6" md="2" v-if="devedor.cnpj != null && devedor.cnpj != ''">
                          <label>CNPJ</label>
                      </b-col>
                      <b-col sm="6" md="4" v-if="devedor.cnpj != null && devedor.cnpj != ''">
                          <p>{{ devedor.cnpj }}</p>
                      </b-col>
                  </b-row>
                  <b-row class="mt-1 mb-0" v-if="devedor.cadicms != null && devedor.cadicms != ''">
                    <b-col sm="6" md="2">
                      <label>CADICMS:</label>
                    </b-col>
                    <b-col sm="6" md="4">
                      <p>{{ devedor.cadicms }}</p>
                    </b-col>
                    <b-col sm="6" md="2">
                      <label>Situação CADICMS:</label>
                    </b-col>
                    <b-col sm="6" md="4">
                      <p>{{ devedor.situacaoCadicms }}</p>
                    </b-col>
                  </b-row>
                  <b-row class="mt-1 mb-0">
                    <b-col sm="6" md="2">
                      <label>Endereço:</label>
                    </b-col>
                    <b-col sm="6" md="4">
                      <p>{{ devedor.logradouro }}</p>
                    </b-col>
                    <b-col sm="6" md="2">
                      <label>Nº:</label>
                    </b-col>
                    <b-col sm="6" md="4">
                      <p>{{ devedor.numero }}</p>
                    </b-col>
                  </b-row>
                  <b-row class="mt-1 mb-0">
                    <b-col sm="6" md="2">
                      <label>Complemento:</label>
                    </b-col>
                    <b-col sm="6" md="4">
                      <p>{{ devedor.complemento }}</p>
                    </b-col>
                    <b-col sm="6" md="2">
                      <label>Bairro:</label>
                    </b-col>
                    <b-col sm="6" md="4">
                      <p>{{ devedor.bairro }}</p>
                    </b-col>
                  </b-row>
                  <b-row class="mt-1 mb-0">
                    <b-col sm="6" md="2">
                      <label>Cidade:</label>
                    </b-col>
                    <b-col sm="6" md="4">
                      <p>{{ devedor.municipio }}</p>
                    </b-col>
                    <b-col sm="6" md="2">
                      <label>Estado:</label>
                    </b-col>
                    <b-col sm="6" md="4">
                      <p>{{ devedor.uf }}</p>
                    </b-col>
                  </b-row>
                  <b-row class="mt-1 mb-0">
                    <b-col sm="6" md="2">
                      <label>CEP:</label>
                    </b-col>
                    <b-col sm="6" md="4">
                      <p>{{ devedor.cep }}</p>
                    </b-col>
                  </b-row>
                </div>
              </b-tab>
              <b-tab title="Exigibilidade" title-link-class="text-title">
                <b-row class="mt-1 mb-0">
                  <b-col sm="6" md="2">
                    <label>Último TAP:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <p>{{ dadosCda.ultimoTap }}</p>
                  </b-col>
                  <b-col sm="6" md="2">
                    <label>Data:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <p>{{ dadosCda.dataExibigilidade }}</p>
                  </b-col>
                </b-row>
                <b-row class="mt-1 mb-0">
                  <b-col sm="6" md="2">
                    <label>Modalidade:</label>
                  </b-col>
                  <b-col sm="6" md="10">
                    <p>{{ dadosCda.modalidade }}</p>
                  </b-col>
                </b-row>

                <hr class="mt-4"/>

                <b-row class="mt-1 mb-0">
                  <b-col>
                    <label>Bloqueios:</label>
                  </b-col>
                </b-row>
                <b-row class="mt-1 mb-0 overflow-grid-extrato">
                  <b-table
                      id="bloqueios"
                      ref="tableBloqueios"
                      :items="bloqueiosTemp"
                      :fields="fieldsBloqueios"
                      striped
                      small
                      responsive="sm"
                      :busy="false"
                      show-empty
                      hover
                      bordered
                      sort-icon-left
                      class="mb-0 col-12">
                    <div slot="table-busy" class="text-center text-primary my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong> Carregando...</strong>
                    </div>
                    <template slot="empty">
                      <p class="my-auto">Nenhum bloqueio encontrado.</p>
                    </template>
                      <template slot="HEAD_ativo">
                      Ativo <i class="filter" :class="!isEmpty(filtrosBloqueio.ativo) ? 'fa fa-filter' : 'filter-empty'"
                               @click="openFilterPopup('Ativo', 'radio', 'Sim,Não', null, $event)"></i>
                    </template>
                    <template slot="HEAD_codigo">
                      Código <i class="filter"
                                :class="!isEmpty(filtrosBloqueio.codigo) ? 'fa fa-filter' : 'filter-empty'"
                                @click="openFilterPopup('Código', 'mascara', '', '#########', $event)"></i>
                    </template>
                    <template slot="HEAD_descricao">
                      Descrição <i class="filter"
                                   :class="!isEmpty(filtrosBloqueio.descricao) || filtrosBloqueio.filtrarDescricao == 3 ? 'fa fa-filter' : 'filter-empty'"
                                   @click="openFilterPopup('Descrição', 'texto', '', null, $event)"></i>
                    </template>
                    <template slot="HEAD_dataBloqueio">
                      Data Bloqueio <i class="filter"
                                       :class="!isEmpty(filtrosBloqueio.dataBloqueio) || filtrosBloqueio.filtrarDataBloqueio == 5 ? 'fa fa-filter' : 'filter-empty'"
                                       @click="openFilterPopup('Data Bloqueio', 'data', '', null, $event)"></i>
                    </template>
                    <template slot="HEAD_dataLiberacao">
                      Data Liberação <i class="filter"
                                        :class="!isEmpty(filtrosBloqueio.dataLiberacao) || filtrosBloqueio.filtrarDataLiberacao == 5 ? 'fa fa-filter' : 'filter-empty'"
                                        @click="openFilterPopup('Data Liberação', 'data', '', null, $event)"></i>
                    </template>
                    <template slot="HEAD_referencia">
                      Referência <i class="filter"
                                    :class="!isEmpty(filtrosBloqueio.referencia) || filtrosBloqueio.filtrarReferencia == 3 ? 'fa fa-filter' : 'filter-empty'"
                                    @click="openFilterPopup('Referência', 'texto', '', null, $event)"></i>
                    </template>
                    <template slot="HEAD_complemento">
                      Complemento <i class="filter"
                                     :class="!isEmpty(filtrosBloqueio.complemento) || filtrosBloqueio.filtrarComplemento == 3 ? 'fa fa-filter' : 'filter-empty'"
                                     @click="openFilterPopup('Complemento', 'texto', '', null, $event)"></i>
                    </template>
                  </b-table>
                </b-row>
              </b-tab>
              <b-tab title="Eventos" title-link-class="text-title" @click="carregarEventos()">
                <b-row class="mt-0 mb-0" v-if="eventosTemp != null">
                  <b-col>
                    <label>Histórico de Eventos:</label>
                  </b-col>
                </b-row>
                <b-row class="mt-1 mb-0 overflow-grid-extrato" v-if="eventosTemp != null">
                  <b-table
                      id="pagamentos"
                      ref="tablePagamentos"
                      :items="eventosTemp"
                      :fields="fieldsEventos"
                      striped
                      small
                      responsive="sm"
                      :busy="false"
                      show-empty
                      hover
                      bordered
                      sort-icon-left
                      class="mb-0 col-12"
                      head-variant="light">
                    <div slot="table-busy" class="text-center text-primary my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong> Carregando...</strong>
                    </div>
                    <template slot="empty">
                      <p class="my-auto">Nenhum evento encontrado.</p>
                    </template>
                    <template slot="HEAD_dataEvento">
                        <p style="min-width: 110px;">
                            Data Evento <i class="filter"
                                           :class="!isEmpty(filtrosEventos.dataEvento) || filtrosEventos.filtrarDataEvento == 5 ? 'fa fa-filter' : 'filter-empty'"
                                           @click="openFilterPopup('Data Evento', 'data', '', null, $event)"></i>
                        </p>
                    </template>
                    <template slot="HEAD_dataFim">
                        <p style="min-width: 90px;">
                            Data Fim <i class="filter"
                                        :class="!isEmpty(filtrosEventos.dataFim) || filtrosEventos.filtrarDataFim == 5 ? 'fa fa-filter' : 'filter-empty'"
                                        @click="openFilterPopup('Data Fim', 'data', '', null, $event)"></i>
                        </p>
                    </template>
                    <template slot="HEAD_codigo">
                        <p style="min-width: 80px;">
                            Código <i class="filter"
                                      :class="!isEmpty(filtrosEventos.codigo) ? 'fa fa-filter' : 'filter-empty'"
                                      @click="openFilterPopup('Código', 'mascara', '', '#########', $event)"></i>
                        </p>
                    </template>
                    <template slot="HEAD_descricao">
                      Descrição <i class="filter"
                                   :class="!isEmpty(filtrosEventos.descricao) || filtrosEventos.filtrarDescricao == 3 ? 'fa fa-filter' : 'filter-empty'"
                                   @click="openFilterPopup('Descrição', 'texto', '', null, $event)"></i>
                    </template>
                    <template slot="HEAD_moeda">
                        <p style="min-width: 80px;">
                            Moeda <i class="filter"
                                     :class="!isEmpty(filtrosEventos.moeda) || filtrosEventos.filtrarMoeda == 3 ? 'fa fa-filter' : 'filter-empty'"
                                     @click="openFilterPopup('Moeda', 'texto', '', null, $event)"></i>
                        </p>
                    </template>
                    <template slot="HEAD_valor">
                        <p style="min-width: 65px;">
                            Valor <i class="filter"
                                     :class="!isEmpty(filtrosEventos.valor) || filtrosEventos.filtrarValor == 5 ? 'fa fa-filter' : 'filter-empty'"
                                     @click="openFilterPopup('Valor', 'numerico', '', null, $event)"></i>
                        </p>
                    </template>
                    <template slot="HEAD_complemento">
                      Complemento <i class="filter"
                                     :class="!isEmpty(filtrosEventos.complemento) || filtrosEventos.filtrarComplemento == 3 ? 'fa fa-filter' : 'filter-empty'"
                                     @click="openFilterPopup('Complemento', 'texto', '', null, $event)"></i>
                    </template>
                  </b-table>
                </b-row>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
      <template v-slot:modal-footer="{ hide }">
        <b-button variant="outline-secondary mr-auto" @click=hide()><i class="fa fa-reply"></i> Voltar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import formatarMixins from '../../../mixins/formatarMixins';
import CompFiltroGrid from "../../shared/components/CompFiltroGrid"

export default {
  components: {CompFiltroGrid},
  mixins: [formatarMixins],
  data() {
    return {
      urlApi: null,
      token: null,
      tabIndex: 0,
      messageModal: {
        message: null,
        variant: null
      },
      codCdaSefa: null,
      dadosCda: {
        contribuintes: []
      },
      fieldsEventos: [
        {
          key: 'dataEvento',
          label: 'Data Evento'
        },
        {
          key: 'dataFim',
          label: 'Data Fim'
        },
        {
          key: 'codigo',
          label: 'Código'
        },
        {
          key: 'descricao',
          label: 'Descrição'
        },
        {
          key: 'moeda',
          label: 'Moeda'
        },
        {
          key: 'valor',
          label: 'Valor'
        },
        {
          key: 'complemento',
          label: 'Complemento'
        }
      ],
      eventosTemp: [],
      fieldsBloqueios: [
        {
          key: 'ativo',
          label: 'Ativo'
        },
        {
          key: 'codigo',
          label: 'Código'
        },
        {
          key: 'descricao',
          label: 'Descrição'
        },
        {
          key: 'dataBloqueio',
          label: 'Data Bloqueio'
        },
        {
          key: 'dataLiberacao',
          label: 'Data Liberação'
        },
        {
          key: 'referencia',
          label: 'Referência'
        },
        {
          key: 'complemento',
          label: 'Complemento'
        }
      ],
      bloqueiosTemp: [],
      filtro: {
          tipo: null,
          campoFiltro: null,
          filtrarEm: null,
          campoValor: null,
          campoMascara: null,
          listaValores: []
      },
      filtrosEventos: {
        filtrarDataEvento: null,
        dataEvento: null,
        filtrarDataFim: null,
        dataFim: null,
        codigo: null,
        filtrarDescricao: null,
        descricao: null,
        filtrarMoeda: null,
        moeda: null,
        filtrarValor: null,
        valor: null,
        filtrarComplemento: null,
        complemento: null,
      },
      filtrosBloqueio: {
        ativo: null,
        codigo: null,
        filtrarDescricao: null,
        descricao: null,
        filtrarDataBloqueio: null,
        dataBloqueio: null,
        filtrarDataLiberacao: null,
        dataLiberacao: null,
        filtrarReferencia: null,
        referencia: null,
        filtrarComplemento: null,
        complemento: null,
      }
    }
  },
  computed: {
    getTheme() {
      return this.$store.getters.getTheme
    },
  },
  methods: {
    abrirExtrato(codCdaSefa) {
      this.limparMsgsModal();

      this.codCdaSefa = codCdaSefa;

      axios.get(`${this.urlApi}/v1/extratoCda/carregarExtrato/${codCdaSefa}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': this.token
        }
      }).then(response => {
        if(response == null || response.data == null || response.data == '') {
          this.dadosCda = {
            mensagemErro: 'O serviço da SEFA está indisponível no momento. Tente mais tarde.'
          };
          this.$refs['modal-erro-mainframe'].show();
          return;
        }

        this.dadosCda = response.data;

        if (this.dadosCda.mensagemErro == 'naoEncontrado') {
          this.$refs['modal-nao-encontrado'].show();
        } else if (this.dadosCda.mensagemErro != null) {
          this.$refs['modal-erro-mainframe'].show();
        } else {
          this.bloqueiosTemp = [];
          this.dadosCda.listaBloqueios.forEach(el => {
            this.bloqueiosTemp.push(el);
          });
          this.eventosTemp = null;
          this.$refs['modal-cda'].show();

          setTimeout(() => {
            var tabelas = document.getElementsByClassName("thead-light");
            for (let i = 0; i < tabelas.length; i++) {
              tabelas[i].style.position = 'sticky';
              tabelas[i].style.top = '-2px';
            }
          }, 200);
        }
      }).catch((error) => {
        this.exibirErro(error)
      });
    },
    async relatorioPDF() {
      axios.get(`${this.urlApi}/v1/extratoCda/exportarExtratoCda/${this.codCdaSefa}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': this.token
        },
        responseType: 'arraybuffer'
      })
          .then(response => {
            let blob = new Blob([response.data], {type: 'application/pdf'});
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'CDA_' + this.codCdaSefa + '.pdf';
            link.click();
      })
    },
    limparMsgsModal() {
      this.messageModal = {
        message: null,
        variant: null
      };
    },
    close() {
      this.$emit('closeModal');
    },
    openFilterPopup(campo, tipo, values, mascara, event) {
      if (document.getElementById('popupExtrato').style.display == 'block'
          && this.filtro.campoFiltro == campo) {
        this.$refs.compFiltro.closeFilterPopup();
      } else {
        this.filtro.tipo = tipo;
        this.filtro.campoFiltro = campo;
        this.filtro.mascara = mascara;

        if (this.tabIndex == 2) {
          if (this.filtro.campoFiltro == 'Ativo') {
            this.filtro.campoValor = this.filtrosBloqueio.ativo;
          } else if (this.filtro.campoFiltro == 'Código') {
            this.filtro.campoMascara = this.filtrosBloqueio.codigo;
          } else if (this.filtro.campoFiltro == 'Descrição') {
            this.filtro.filtrarEm = this.filtrosBloqueio.filtrarDescricao;
            this.filtro.campoValor = this.filtrosBloqueio.descricao;
          } else if (this.filtro.campoFiltro == 'Data Bloqueio') {
            this.filtro.filtrarEm = this.filtrosBloqueio.filtrarDataBloqueio;
            this.filtro.campoValor = this.filtrosBloqueio.dataBloqueio;
          } else if (this.filtro.campoFiltro == 'Data Liberação') {
            this.filtro.filtrarEm = this.filtrosBloqueio.filtrarDataLiberacao;
            this.filtro.campoValor = this.filtrosBloqueio.dataLiberacao;
          } else if (this.filtro.campoFiltro == 'Referência') {
            this.filtro.filtrarEm = this.filtrosBloqueio.filtrarReferencia;
            this.filtro.campoValor = this.filtrosBloqueio.referencia;
          } else if (this.filtro.campoFiltro == 'Complemento') {
            this.filtro.filtrarEm = this.filtrosBloqueio.filtrarComplemento;
            this.filtro.campoValor = this.filtrosBloqueio.complemento;
          }
        } else {
          if (this.filtro.campoFiltro == 'Data Evento') {
            this.filtro.filtrarEm = this.filtrosEventos.filtrarDataEvento;
            this.filtro.campoValor = this.filtrosEventos.dataEvento;
          } else if (this.filtro.campoFiltro == 'Data Fim') {
            this.filtro.filtrarEm = this.filtrosEventos.filtrarDataFim;
            this.filtro.campoValor = this.filtrosEventos.dataFim;
          } else if (this.filtro.campoFiltro == 'Código') {
            this.filtro.campoMascara = this.filtrosEventos.codigo;
          } else if (this.filtro.campoFiltro == 'Descrição') {
            this.filtro.filtrarEm = this.filtrosEventos.filtrarDescricao;
            this.filtro.campoValor = this.filtrosEventos.descricao;
          } else if (this.filtro.campoFiltro == 'Moeda') {
            this.filtro.filtrarEm = this.filtrosEventos.filtrarMoeda;
            this.filtro.campoValor = this.filtrosEventos.moeda;
          } else if (this.filtro.campoFiltro == 'Valor') {
            this.filtro.filtrarEm = this.filtrosEventos.filtrarValor;
            this.filtro.campoValor = this.filtrosEventos.valor;
          } else if (this.filtro.campoFiltro == 'Complemento') {
            this.filtro.filtrarEm = this.filtrosEventos.filtrarComplemento;
            this.filtro.campoValor = this.filtrosEventos.complemento;
          }
        }

        if (this.filtro.tipo == "checkbox") {
          this.filtro.listaValores = values;
        } else if (values != null && values != "") {
          this.filtro.listaValores = values.split(',');
        }

        if (this.tabIndex == 2) {
          this.$refs.compFiltro.openCloseFilterPopup(event, true, 400, 250);
        } else {
          this.$refs.compFiltro.openCloseFilterPopup(event, true, 400, 145);
        }
      }
    },
    filtrarResultados(limpar) {
      if (limpar) {
        this.filtro.filtrarEm = null
        this.filtro.campoValor = null
        this.filtro.campoValor = null
        this.filtro.campoRadio = null
        this.filtro.campoCheckbox = null
        this.filtro.campoMascara = null
      }

      if (this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
        this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
      }

      if (this.tabIndex == 2) {
        if (this.filtro.campoFiltro == 'Ativo') {
          this.filtrosBloqueio.ativo = this.filtro.campoValor;
        } else if (this.filtro.campoFiltro == 'Código') {
          this.filtrosBloqueio.codigo = this.filtro.campoMascara;
        } else if (this.filtro.campoFiltro == 'Descrição') {
          this.filtrosBloqueio.filtrarDescricao = this.filtro.filtrarEm;
          this.filtrosBloqueio.descricao = this.filtro.campoValor;
        } else if (this.filtro.campoFiltro == 'Data Bloqueio') {
          this.filtrosBloqueio.filtrarDataBloqueio = this.filtro.filtrarEm;
          this.filtrosBloqueio.dataBloqueio = this.filtro.campoValor;
        } else if (this.filtro.campoFiltro == 'Data Liberação') {
          this.filtrosBloqueio.filtrarDataLiberacao = this.filtro.filtrarEm;
          this.filtrosBloqueio.dataLiberacao = this.filtro.campoValor;
        } else if (this.filtro.campoFiltro == 'Referência') {
          this.filtrosBloqueio.filtrarReferencia = this.filtro.filtrarEm;
          this.filtrosBloqueio.referencia = this.filtro.campoValor;
        } else if (this.filtro.campoFiltro == 'Complemento') {
          this.filtrosBloqueio.filtrarComplemento = this.filtro.filtrarEm;
          this.filtrosBloqueio.complemento = this.filtro.campoValor;
        }
      } else {
        if (this.filtro.campoFiltro == 'Data Evento') {
          this.filtrosEventos.filtrarDataEvento = this.filtro.filtrarEm;
          this.filtrosEventos.dataEvento = this.filtro.campoValor;
        } else if (this.filtro.campoFiltro == 'Data Fim') {
          this.filtrosEventos.filtrarDataFim = this.filtro.filtrarEm;
          this.filtrosEventos.dataFim = this.filtro.campoValor;
        } else if (this.filtro.campoFiltro == 'Código') {
          this.filtrosEventos.codigo = this.filtro.campoMascara;
        } else if (this.filtro.campoFiltro == 'Descrição') {
          this.filtrosEventos.filtrarDescricao = this.filtro.filtrarEm;
          this.filtrosEventos.descricao = this.filtro.campoValor;
        } else if (this.filtro.campoFiltro == 'Moeda') {
          this.filtrosEventos.filtrarMoeda = this.filtro.filtrarEm;
          this.filtrosEventos.moeda = this.filtro.campoValor;
        } else if (this.filtro.campoFiltro == 'Valor') {
          this.filtrosEventos.filtrarValor = this.filtro.filtrarEm;
          this.filtrosEventos.valor = this.filtro.campoValor;
        } else if (this.filtro.campoFiltro == 'Complemento') {
          this.filtrosEventos.filtrarComplemento = this.filtro.filtrarEm;
          this.filtrosEventos.complemento = this.filtro.campoValor;
        }
      }

      this.consultarGrids();
    },
    ordenarResultados(order) {
      let campoOrdenacao;
      if (this.tabIndex == 2) {
        if (this.filtro.campoFiltro == 'Ativo') {
          campoOrdenacao = 'ativo';
        } else if (this.filtro.campoFiltro == 'Código') {
          campoOrdenacao = 'codigo';
        } else if (this.filtro.campoFiltro == 'Descrição') {
          campoOrdenacao = 'descricao';
        } else if (this.filtro.campoFiltro == 'Data Bloqueio') {
          campoOrdenacao = 'dataBloqueio';
        } else if (this.filtro.campoFiltro == 'Data Liberação') {
          campoOrdenacao = 'dataLiberacao';
        } else if (this.filtro.campoFiltro == 'Referência') {
          campoOrdenacao = 'referencia';
        } else if (this.filtro.campoFiltro == 'Complemento') {
          campoOrdenacao = 'complemento';
        }
      } else {
        if (this.filtro.campoFiltro == 'Data Evento') {
          campoOrdenacao = 'dataEvento';
        } else if (this.filtro.campoFiltro == 'Data Fim') {
          campoOrdenacao = 'dataFim';
        } else if (this.filtro.campoFiltro == 'Código') {
          campoOrdenacao = 'codigo';
        } else if (this.filtro.campoFiltro == 'Descrição') {
          campoOrdenacao = 'descricao';
        } else if (this.filtro.campoFiltro == 'Moeda') {
          campoOrdenacao = 'moeda';
        } else if (this.filtro.campoFiltro == 'Valor') {
          campoOrdenacao = 'valor';
        } else if (this.filtro.campoFiltro == 'Complemento') {
          campoOrdenacao = 'complemento';
        }
      }

      this.consultarGrids(campoOrdenacao, order);
    },
    async consultarGrids(campoOrdenacao, order) {
      let ordenacao = '';
      if (campoOrdenacao != null && order != null) {
        ordenacao = `?sortField=${campoOrdenacao}&sortOrder=${order}`;
      }

      let filtroTemp;
      let url;
      if (this.tabIndex == 2) {
        filtroTemp = this.filtrosBloqueio;
        filtroTemp.listaBloqueio = this.dadosCda.listaBloqueios;
        url = 'consultarBloqueiosCda';
      } else {
        filtroTemp = this.filtrosEventos;
        filtroTemp.listaEvento = this.dadosCda.listaEventos;
        url = 'consultarEventosCda';
      }

      axios.post(`${this.urlApi}/v1/extratoCda/${url}${ordenacao}`, filtroTemp, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': this.token
        }
      }).then(response => {
        if (this.tabIndex == 2) {
          this.bloqueiosTemp = response.data;
        } else {
          this.eventosTemp = response.data;
        }
      }).catch((error) => {
        this.exibirErro(error)
      })
    },
    copiarTexto() {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(this.dadosCda.conteudoCopia);
        } else {
            var textArea = document.getElementById('textareaCopy');
            textArea.style.visibility = "visible";
            textArea.select();
            document.execCommand('copy');
            textArea.style.visibility = "hidden";
        }
    },
      carregarEventos() {
          if(this.eventosTemp == null) {
              axios.get(`${this.urlApi}/v1/extratoCda/consultarEventosCda/${this.codCdaSefa}`, {
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': this.token
                  }
              }).then(response => {
                  this.eventosTemp = [];
                  response.data.forEach(el => {
                      this.eventosTemp.push(el);
                  });
                  this.dadosCda.listaEventos = this.eventosTemp;
              }).catch((error) => {
                  this.exibirErro(error)
              });
          }
      },
      fecharModais() {
          this.$refs['modal-cda'].hide();
          this.$refs['modal-nao-encontrado'].hide();
          this.$refs['modal-erro-mainframe'].hide();
      }
  },
  mounted() {
    this.urlApi = process.env.VUE_APP_ROOT_API;
    this.token = JSON.parse(this.$store.getters.getUser).access_token;
  }

}
</script>

<style scoped>

    .no-line {
      white-space: nowrap;
    }

    .btn-outline-secondary {
        color: #6c757d;
        border-color: #6c757d;
    }

    .btn-outline-secondary:hover {
        color: #fff;
        background-color: #6c757d;
        border-color: #6c757d;
    }

</style>

<style>
    .bg-cda {
        background-color: #0073C0 !important;
    }

    .btn-cda {
        color: #fff;
        background-color: #0073C0;
        border-color: #0073C0;
    }

    .btn-cda:hover {
        color: #fff;
        background-color: #005081;
        border-color: #003d65;
    }

    .modal-title {
        margin-bottom: 0;
        line-height: 1.5;
    }

    .card-extrato {
        margin: 0.75rem 0 !important;
    }

    .card-extrato {
        border: 1px solid rgba(0, 0, 0, 0.05) !important;
    }

    .card-header {
        font-weight: bold;
        border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
        padding: 0.75rem 1.25rem;
        margin-bottom: 0;
        background-color: rgba(0, 0, 0, 0);
        border-bottom: 2px solid rgba(0, 0, 0, 0.05);
    }

    .card-header-tabs {
        margin-right: -0.625rem !important;
        margin-bottom: -0.75rem !important;
        margin-left: -0.625rem !important;
        border: 0 !important;
    }

    .nav-link-active {
    }

    .nav-link {
        border: 1px solid transparent;
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
    }

    .text-title {
        color: rgba(0, 0, 0, 0.5) !important;
        font-weight: normal;
    }

    .text-title-selected {
        font-weight: bold;
        color: #495057 !important;
        background-color: #F2F3F9 !important;
        border-color: #dee2e6 #dee2e6 #F2F3F9 !important;
        min-width: 0px;
    }

    .nav-link {
        display: block;
        padding: 0.5rem 1rem;
    }

    p {
        margin: 0;
        padding: 0;
    }

    .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
        border: 1px solid #e9ecef !important;
    }

     .text-title:hover {
         color: rgba(0, 0, 0, 0.8);
     }

    .overflow-grid-extrato {
        max-height: 279px;
        overflow: auto;
    }
</style>
